import { PackService } from './../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SharedService } from '../../../../../shared/services/shared.service';
import { Category } from '../../../../admin-panel/components/pages/category/models/category';
import { CategoryService } from '../../../../admin-panel/components/pages/category/services/category.service';
import { environment } from '../../../../../environments/environment';
import {DropdownToggleService} from "../../../../../shared/services/dropdown-toggle.service";
import { CategoryPackVM } from '../../../../contributor/components/profile/contributors/pack/models/pack';

@Component({
  selector: 'app-dashboard',
  standalone:false,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {

  }

}
